export default "__VITE_ASSET__4f87b249__"